import { atPlant, unresolved } from './rules';
import type { AccessRule, Scope } from './rules';

export const allowedAtEveryPlant = (
  check: (rule: AccessRule, scope: Scope) => boolean,
  rule: AccessRule,
  plantIds: readonly string[],
  whenNoPlant: Scope = unresolved,
): boolean => (plantIds.length === 0 ? check(rule, whenNoPlant) : plantIds.every((plantId) => check(rule, atPlant(plantId))));
